module.exports = __webpack_public_path__ + "201811/img/top_12.cb967c6b.png";